<template>
  <svg :width="`calc(36 / 20 * ${size})`" :height="size" viewBox="0 0 36 22" fill="none" v-on="$listeners">
    <path d="M18 0C10.1497 0 3.3435 4.4704 0 11C3.3435 17.5296 10.1497 22 18 22C25.8503 22 32.6565 17.5296 36 11C32.6565 4.4704 25.8503 0 18 0ZM26.8762 5.8344C28.9912 7.1544 30.7845 8.921 32.13 11C30.7883 13.0785 28.9945 14.8422 26.8762 16.1656C24.2255 17.8204 21.1461 18.6996 18.0011 18.6996C14.8562 18.6996 11.7768 17.8204 9.126 16.1656C7.00773 14.8422 5.21391 13.0785 3.87225 11C5.30227 8.78522 7.24445 6.9299 9.54225 5.5836C9.04767 6.91294 8.88813 8.33927 9.07714 9.74172C9.26616 11.1442 9.79816 12.4814 10.6281 13.6401C11.458 14.7987 12.5613 15.7447 13.8446 16.3979C15.1279 17.051 16.5533 17.392 18 17.392C19.4467 17.392 20.8721 17.051 22.1554 16.3979C23.4387 15.7447 24.542 14.7987 25.3719 13.6401C26.2018 12.4814 26.7338 11.1442 26.9229 9.74172C27.1119 8.33927 26.9523 6.91294 26.4578 5.5836C26.5972 5.66573 26.7382 5.74933 26.8762 5.8344ZM18 7.7C17.9997 8.57551 17.6437 9.41504 17.0104 10.0339C16.377 10.6528 15.5182 11.0003 14.6228 11C13.7273 10.9997 12.8687 10.6516 12.2358 10.0324C11.6029 9.41307 11.2475 8.57331 11.2478 7.6978C11.248 6.82229 11.604 5.98276 12.2374 5.36389C12.8707 4.74502 13.7296 4.39751 14.625 4.3978C15.5204 4.39809 16.379 4.74617 17.012 5.36545C17.6449 5.98473 18.0003 6.82449 18 7.7Z" :fill="color"/>
  </svg>
</template>


<script>
export default {
  name: 'IconEye',

  props: {
    size: {
      type: String,
      default: '1em',
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>